import { ReactElement, MouseEvent } from "react";
import { className } from "../../../../shared/helpers";
import { IBranch } from "../../../../services/http/component/models/IBranch";
import { IComponent } from "../../../../services/http/component/models/IComponent";
import { TableColumn } from "../TableWrapper";
import tableStyles from "../ResultsTable.module.scss";
import { ComponentRowViewModel } from "../../ComponentTableViewModel";
import StatusIndicator from "../../../../components/Shared/StatusIndicator";
import styles from "./FixedContent.module.scss";
import { TooltipSetup } from "../../../../hooks/UseTooltip";

interface FixedContentProps
{
    tableColumns: TableColumn[];
    componentRows: ComponentRowViewModel[];
    branches?: IBranch[];
    collapsed: boolean;
    selectedComponent: IComponent;
    setBreadcrumb: (ComponentRow: ComponentRowViewModel, full?: boolean) => ReactElement;
    selectComponent: (x: IComponent) => void
    setupTooltip: (x: TooltipSetup) => void;
}

const FixedContent = (props: FixedContentProps): ReactElement =>
{
    function handleMouseEnter(branches: ComponentRowViewModel, event: MouseEvent): void
    {
        const { x, y } = event.currentTarget.getBoundingClientRect();

        const children = props.setBreadcrumb(branches, true).props.children;

        if(children.length > 0)
        {
            props.setupTooltip({
                position: { x, y },
                customClassName: styles.tooltip,
                content: children
            })
        }
    }

    return (
        <>
            {props.componentRows.map((x, i) => (
                <tr
                    key={`fixed_row_${i}`}
                    data-row={i}
                    onClick={() => props.selectComponent(x.component)}
                    {...className(
                        tableStyles.tableRow, {
                        "active": props.selectedComponent?.id === x.component.id,
                        [styles.collapsed]: props.collapsed
                    })}
                >
                    <td data-column="Health" className={styles.health}>
                        <StatusIndicator component={x.component} />
                    </td>

                    <td
                        data-column="Name"
                        className={styles.name}
                        onMouseEnter={e => handleMouseEnter(x, e)}
                    >
                        {!props.collapsed && <small>{props.setBreadcrumb(x)}</small>}
                        <p>{x.component.name}</p>
                    </td>
                </tr>
            ))}
        </>
    )
}

export default FixedContent;